// "use client";
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Button,
//   Input,
//   Tag,
//   Spin,
//   Badge,
//   Switch,
//   DatePicker,
//   Modal,
//   Upload,
// } from "antd";
// import {
//   ArrowLeftOutlined,
//   SaveOutlined,
//   PictureOutlined,
//   DeleteOutlined,
//   SettingOutlined,
//   UploadOutlined,
//   PlusOutlined,
// } from "@ant-design/icons";
// import {
//   IconStar,
//   IconTag,
//   IconLayoutList,
//   IconCalendar,
// } from "@tabler/icons-react";
// import { useNavigate, useParams } from "react-router-dom";
// import EditorJS from "@editorjs/editorjs";
// import Header from "@editorjs/header";
// import List from "@editorjs/list";
// import Quote from "@editorjs/quote";
// import Delimiter from "@editorjs/delimiter";
// import dayjs from "dayjs";
// import api from "../../../api";
// import Select from "antd/es/select";
// import { useToast } from "../../../components/toast";
// import ConfirmModal from "../../../components/modal/ConfirmModal";

// const EDITOR_ID = "news-editorjs";

// export default function NewsDetail() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const editorInstanceRef = useRef(null);
//   const titleRef = useRef(null);

//   const [news, setNews] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);

//   const [title, setTitle] = useState("");
//   const [excerpt, setExcerpt] = useState("");
//   const [status, setStatus] = useState("DRAFT");
//   const [featured, setFeatured] = useState(false);
//   const [publishedAt, setPublishedAt] = useState(null);
//   const [slug, setSlug] = useState("");

//   const [categories, setCategories] = useState([]);
//   const [tags, setTags] = useState([]);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);

//   // Thumb
//   const [thumbPreview, setThumbPreview] = useState(null);
//   const [thumbUploading, setThumbUploading] = useState(false);
//   const [thumbSourceOpen, setThumbSourceOpen] = useState(false);

//   // Cover
//   const [coverPreview, setCoverPreview] = useState(null);
//   const [coverUploading, setCoverUploading] = useState(false);
//   const [coverSourceOpen, setCoverSourceOpen] = useState(false);

//   // Media modal
//   const [mediaModalOpen, setMediaModalOpen] = useState(false);
//   const [mediaImages, setMediaImages] = useState([]);
//   const [mediaLoading, setMediaLoading] = useState(false);
//   // coverSourceOpen устгах
//   const [mediaTarget, setMediaTarget] = useState("cover"); // "cover" | "thumb"

//   // Delete
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
//   const [deleting, setDeleting] = useState(false);

//   const toast = useToast();

//   // title утга тавигдсаны дараа өндөр тохируулах
//   useEffect(() => {
//     if (!titleRef.current || !title) return;
//     const el = titleRef.current;
//     el.style.height = "auto";
//     el.style.height = el.scrollHeight + "px";
//   }, [title, loading]); // loading дуусаад title бэлэн болоход ажиллана

//   // ── Media татах ───────────────────────────────────
//   useEffect(() => {
//     if (!mediaModalOpen) return;
//     const fetchMedia = async () => {
//       setMediaLoading(true);
//       const res = await api.media_list();
//       if (res?.status === 200) {
//         setMediaImages(res.data || []);
//       } else {
//         toast("Медиа авахад алдаа гарлаа", "error");
//       }
//       setMediaLoading(false);
//     };
//     fetchMedia();
//   }, [mediaModalOpen]);

//   // ── Taxonomy татах ────────────────────────────────
//   useEffect(() => {
//     const fetch_ = async () => {
//       try {
//         const res = await api.news_taxonomies_list();
//         const list = res.data.data || [];
//         setCategories(
//           list
//             .filter((t) => t.type === "CATEGORY")
//             .map((t) => ({ label: t.name, value: t.id, color: t.color })),
//         );
//         setTags(
//           list
//             .filter((t) => t.type === "TAG")
//             .map((t) => ({ label: t.name, value: t.id })),
//         );
//       } catch {}
//     };
//     fetch_();
//   }, []);

//   // ── Мэдээ татах ───────────────────────────────────
//   useEffect(() => {
//     const fetchNews = async () => {
//       setLoading(true);
//       const res = await api.news_detail(slug);

//       console.log(res);
//       if (res.status === 200) {
//         const item = res.data.data;
//         setNews(item);
//         setTitle(item.title || "");
//         setExcerpt(item.excerpt || "");
//         setStatus(item.status || "DRAFT");
//         setFeatured(item.featured || false);
//         setPublishedAt(item.publishedAt ? dayjs(item.publishedAt) : null);
//         setSlug(item.slug || "");
//         setSelectedCategories(
//           item.taxonomies
//             ?.filter((t) => t.type === "CATEGORY")
//             .map((t) => t.id) || [],
//         );
//         setSelectedTags(
//           item.taxonomies?.filter((t) => t.type === "TAG").map((t) => t.id) ||
//             [],
//         );
//         if (item.cover?.url) setCoverPreview(item.cover.url);
//         if (item.thumbnail?.url) setThumbPreview(item.thumbnail.url);
//       } else {
//         toast(res?.data?.message || "Мэдээ татахад алдаа гарлаа", "error");
//       }
//       setLoading(false);
//     };
//     fetchNews();
//   }, [slug]);

//   // ── EditorJS init ─────────────────────────────────
//   useEffect(() => {
//     if (loading || !news) return;

//     const initEditor = async () => {
//       if (editorInstanceRef.current) {
//         try {
//           await editorInstanceRef.current.isReady;
//           editorInstanceRef.current.destroy();
//         } catch {}
//         editorInstanceRef.current = null;
//       }

//       let initialData = { blocks: [] };
//       try {
//         if (news.content) initialData = JSON.parse(news.content);
//       } catch {}

//       editorInstanceRef.current = new EditorJS({
//         holder: EDITOR_ID,
//         tools: {
//           header: { class: Header, inlineToolbar: true },
//           list: { class: List, inlineToolbar: true },
//           quote: { class: Quote, inlineToolbar: true },
//           delimiter: Delimiter,
//         },
//         data: initialData,
//         placeholder: "Агуулгаа энд бичнэ үү...",
//       });
//     };

//     initEditor();

//     return () => {
//       if (editorInstanceRef.current) {
//         editorInstanceRef.current.isReady
//           .then(() => {
//             editorInstanceRef.current?.destroy();
//             editorInstanceRef.current = null;
//           })
//           .catch(() => {
//             editorInstanceRef.current = null;
//           });
//       }
//     };
//   }, [loading, news]);

//   // ── Thumb: компьютерээс upload ────────────────────
//   const handleThumbUpload = async ({ file }) => {
//     setThumbUploading(true);
//     const formData = new FormData();
//     formData.append("image", file);
//     const res = await api.upload_image(formData);
//     if (res?.status === 201) {
//       setThumbPreview(res.data.url);
//       setThumbSourceOpen(false);
//       toast("Зураг амжилттай байршлаа", "success");
//     } else {
//       toast("Зураг байршуулахад алдаа гарлаа", "error");
//     }
//     setThumbUploading(false);
//   };

//   // ── Cover: компьютерээс upload ────────────────────
//   const handleCoverUpload = async ({ file }) => {
//     setCoverUploading(true);
//     const formData = new FormData();
//     formData.append("image", file);
//     const res = await api.upload_image(formData);
//     if (res?.status === 201) {
//       setCoverPreview(res.data.url);
//       setCoverSourceOpen(false);
//       toast("Зураг амжилттай байршлаа", "success");
//     } else {
//       toast("Зураг байршуулахад алдаа гарлаа", "error");
//     }
//     setCoverUploading(false);
//   };

//   // ── Cover: зургийн сангаас сонгох ─────────────────
//   // const handleSelectFromMedia = (url) => {
//   //   setCoverPreview(url);
//   //   setMediaModalOpen(false);
//   // };
//   const handleSelectFromMedia = (url) => {
//     if (mediaTarget === "thumb") {
//       setThumbPreview(url);
//     } else {
//       setCoverPreview(url);
//     }
//     setMediaModalOpen(false);
//   };

//   // ── Cover: устгах ─────────────────────────────────
//   const handleRemoveCover = (e) => {
//     e.stopPropagation();
//     setCoverPreview(null);
//     setCoverSourceOpen(false);
//   };

//   // ── Хадгалах ──────────────────────────────────────
//   const handleSave = async (publishOverride) => {
//     setSaving(true);
//     const editorData = await editorInstanceRef?.current?.save();
//     const taxonomyIds = [...selectedCategories, ...selectedTags];
//     const newStatus = publishOverride ?? status;

//     // Cover тооцоолох
//     let coverData = news?.cover || null;
//     if (coverPreview && coverPreview !== news?.cover?.url) {
//       coverData = { url: coverPreview };
//     } else if (!coverPreview) {
//       coverData = null;
//     }

//     // Thumbnail тооцоолох ← нэмэх
//     let thumbnailData = news?.thumbnail || null;
//     if (thumbPreview && thumbPreview !== news?.thumbnail?.url) {
//       thumbnailData = { url: thumbPreview };
//     } else if (!thumbPreview) {
//       thumbnailData = null;
//     }

//     const res = await api.news_update(slug, {
//       title,
//       slug,
//       excerpt,
//       content: JSON.stringify(editorData),
//       status: newStatus,
//       featured,
//       taxonomyIds,
//       publishedAt: publishedAt ? publishedAt.toISOString() : null,
//       cover: coverData,
//       thumbnail: thumbnailData,
//     });

//     if (res.status === 200) {
//       setNews((prev) => ({ ...prev, status: newStatus }));
//       if (publishOverride) setStatus(publishOverride);

//       toast(
//         publishOverride === "PUBLISHED" ? "Нийтлэгдлээ" : "Хадгалагдлаа",
//         "success",
//       );
//     } else {
//       toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
//     }
//     setSaving(false);
//   };

//   // ── Устгах ────────────────────────────────────────
//   const handleDelete = async () => {
//     setDeleting(true);
//     try {
//       await api.news_delete(id);
//       toast("Устгагдлаа", "success");
//       navigate("/news");
//     } catch {
//       toast("Устгахад алдаа гарлаа", "error");
//     } finally {
//       setDeleting(false);
//       setDeleteConfirmOpen(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         style={{ display: "flex", justifyContent: "center", paddingTop: 80 }}
//       >
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <section className="news-detail-section">
//       {/* ── Topbar ── */}
//       <div className="nd-topbar">
//         <Button
//           icon={<ArrowLeftOutlined />}
//           variant="text"
//           color="default"
//           onClick={() => navigate("/news")}
//         >
//           Буцах
//         </Button>
//         <div className="nd-topbar-right">
//           <Badge
//             dot
//             color={news?.status === "PUBLISHED" ? "green" : "gold"}
//             text={
//               <span style={{ fontSize: 13, color: "#000", fontWeight: 500 }}>
//                 {news?.status === "PUBLISHED" ? "Нийтлэгдсэн" : "Ноорог"}
//               </span>
//             }
//           />
//           <Button
//             icon={<SaveOutlined />}
//             loading={saving}
//             onClick={() => handleSave()}
//           >
//             Хадгалах
//           </Button>
//         </div>
//       </div>

//       {/* ── Body ── */}
//       <div className="nd-body">
//         {/* ── Editor талбар ── */}
//         <div className="nd-editor-wrap">
//           {/* Cover */}
//           <div className="nd-cover-wrap">
//             {/* Cover */}
//             <div className="nd-cover-wrap">
//               {coverPreview ? (
//                 <div className="nd-cover-preview">
//                   <img src={coverPreview} alt="cover" />
//                   <button
//                     className="nd-cover-remove"
//                     onClick={handleRemoveCover}
//                   >
//                     <DeleteOutlined />
//                   </button>
//                   <div
//                     className="nd-cover-overlay"
//                     onClick={() => {
//                       setMediaTarget("cover");
//                       setMediaModalOpen(true);
//                     }}
//                   >
//                     <PictureOutlined style={{ fontSize: 15 }} />
//                     <span>Зураг солих</span>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="nd-cover-placeholder"
//                   onClick={() => {
//                     setMediaTarget("cover");
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PlusOutlined style={{ fontSize: 14 }} />
//                   <span>Онцлох ковер нэмэх</span>
//                 </div>
//               )}
//             </div>
//             {/* {coverPreview ? (
//               <div className="nd-cover-preview">
//                 <img src={coverPreview} alt="cover" />
//                 <button className="nd-cover-remove" onClick={handleRemoveCover}>
//                   <DeleteOutlined />
//                 </button>
//                 <div
//                   className="nd-cover-overlay"
//                   onClick={() => setCoverSourceOpen((v) => !v)}
//                 >
//                   <PictureOutlined style={{ fontSize: 15 }} />
//                   <span>Зураг солих</span>
//                 </div>
//               </div>
//             ) : (
//               <div
//                 className="nd-cover-placeholder"
//                 onClick={() => setCoverSourceOpen((v) => !v)}
//               >
//                 <PlusOutlined style={{ fontSize: 14 }} />
//                 <span>Онцлох ковер нэмэх</span>
//               </div>
//             )} */}

//             {/* Source сонголт */}
//             {coverSourceOpen && (
//               <div className="nd-cover-source-btns">
//                 <button
//                   className="nd-cover-source-btn"
//                   onClick={() => {
//                     setCoverSourceOpen(false);
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PictureOutlined style={{ fontSize: 16 }} />
//                   <span>Зургийн сангаас</span>
//                 </button>
//                 <Upload
//                   showUploadList={false}
//                   accept="image/jpeg,image/png,image/webp"
//                   customRequest={handleCoverUpload}
//                   disabled={coverUploading}
//                 >
//                   <button
//                     className="nd-cover-source-btn"
//                     disabled={coverUploading}
//                   >
//                     <UploadOutlined style={{ fontSize: 16 }} />
//                     <span>
//                       {coverUploading ? "Байршуулж байна..." : "Компьютерээс"}
//                     </span>
//                   </button>
//                 </Upload>
//               </div>
//             )}
//           </div>

//           {/* Editor агуулга */}
//           <div className="nd-editor-content">
//             <textarea
//               ref={titleRef}
//               className="nd-title-input"
//               placeholder="Гарчиг..."
//               value={title}
//               rows={1}
//               onChange={(e) => {
//                 setTitle(e.target.value);
//                 e.target.style.height = "auto";
//                 e.target.style.height = e.target.scrollHeight + "px";
//               }}
//             />
//             <div id={EDITOR_ID} className="nd-editor" />
//           </div>
//         </div>

//         {/* ── Sidebar ── */}
//         <aside className="nd-sidebar">
//           <div className="nd-sidebar-header">
//             <SettingOutlined style={{ color: "#5e5e5e", fontSize: 15 }} />
//             Тохиргоо
//           </div>

//           {/* Төлөв */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">Төлөв</div>
//             <div className="nd-status-btns">
//               <button
//                 className={`nd-status-btn ${status === "DRAFT" ? "active-draft" : ""}`}
//                 onClick={() => setStatus("DRAFT")}
//               >
//                 Ноорог
//               </button>
//               <button
//                 className={`nd-status-btn ${status === "PUBLISHED" ? "active-published" : ""}`}
//                 onClick={() => setStatus("PUBLISHED")}
//               >
//                 Нийтлэх
//               </button>
//             </div>
//           </div>

//           {/* Thumbnail */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <PictureOutlined size={13} />
//               Thumbnail зураг
//             </div>
//             <div className="nd-sidebar-field">
//               {thumbPreview ? (
//                 <div className="nd-thumb-preview">
//                   <img src={thumbPreview} alt="thumbnail" />
//                   <div className="nd-thumb-actions">
//                     <button
//                       className="nd-thumb-btn"
//                       onClick={() => {
//                         setMediaTarget("thumb");
//                         setMediaModalOpen(true);
//                       }}
//                     >
//                       <PictureOutlined /> Солих
//                     </button>
//                     <button
//                       className="nd-thumb-btn danger"
//                       onClick={() => setThumbPreview(null)}
//                     >
//                       <DeleteOutlined />
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="nd-thumb-placeholder"
//                   onClick={() => {
//                     setMediaTarget("thumb");
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PlusOutlined />
//                   <span>Thumbnail нэмэх</span>
//                 </div>
//               )}
//               {/* {thumbPreview ? (
//                 <div className="nd-thumb-preview">
//                   <img src={thumbPreview} alt="thumbnail" />
//                   <div className="nd-thumb-actions">
//                     <button
//                       className="nd-thumb-btn"
//                       onClick={() => setThumbSourceOpen((v) => !v)}
//                     >
//                       <PictureOutlined /> Солих
//                     </button>
//                     <button
//                       className="nd-thumb-btn danger"
//                       onClick={() => {
//                         setThumbPreview(null);
//                         setThumbSourceOpen(false);
//                       }}
//                     >
//                       <DeleteOutlined />
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="nd-thumb-placeholder"
//                   onClick={() => setThumbSourceOpen((v) => !v)}
//                 >
//                   <PlusOutlined style={{ fontSize: 14 }} />
//                   <span>Thumbnail нэмэх</span>
//                 </div>
//               )} */}

//               {thumbSourceOpen && (
//                 <div className="nd-cover-source-btns">
//                   <button
//                     className="nd-cover-source-btn"
//                     onClick={() => {
//                       setThumbSourceOpen(false);
//                       setMediaModalOpen(true);
//                     }}
//                   >
//                     <PictureOutlined style={{ fontSize: 16 }} />
//                     <span>Зургийн сангаас</span>
//                   </button>
//                   <Upload
//                     showUploadList={false}
//                     accept="image/jpeg,image/png,image/webp"
//                     customRequest={handleThumbUpload}
//                     disabled={thumbUploading}
//                   >
//                     <button
//                       className="nd-cover-source-btn"
//                       disabled={thumbUploading}
//                     >
//                       <UploadOutlined style={{ fontSize: 16 }} />
//                       <span>
//                         {thumbUploading ? "Байршуулж байна..." : "Компьютерээс"}
//                       </span>
//                     </button>
//                   </Upload>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Sidebar дотор — Төлөвийн section-ийн дээр */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconCalendar size={13} />
//               Slug
//             </div>
//             <div className="nd-sidebar-field">
//               <Input
//                 className="nd-sidebar-input"
//                 value={slug}
//                 onChange={(e) => {
//                   // зөвхөн a-z 0-9 - _ зөвшөөрөх
//                   // const val = e.target.value.replace(/[^a-zA-Z0-9_-]/g, "");
//                   setSlug(e.target.value);
//                 }}
//               />
//             </div>
//           </div>

//           {/* Нийтлэх огноо */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconCalendar size={13} />
//               Нийтлэх огноо
//             </div>
//             <div className="nd-sidebar-field">
//               <DatePicker
//                 value={publishedAt}
//                 onChange={setPublishedAt}
//                 showTime
//                 format="YYYY/MM/DD HH:mm"
//                 placeholder="Огноо сонгох"
//                 className="nd-sidebar-input"
//               />
//             </div>
//           </div>

//           {/* Онцлох */}
//           <div className="nd-sidebar-section">
//             <div className="nd-inline-field" style={{ marginBottom: 0 }}>
//               <div className="nd-inline-label">
//                 <IconStar size={15} color="#faad14" />
//                 <span className="nd-sidebar-section-title">
//                   Онцлох мэдээ болгох
//                 </span>
//               </div>
//               <Switch checked={featured} onChange={setFeatured} size="small" />
//             </div>
//           </div>

//           {/* Товч агуулга */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">Товч агуулга</div>
//             <div className="nd-sidebar-field">
//               <Input.TextArea
//                 className="nd-excerpt-textarea"
//                 placeholder="Мэдээний товч тайлбар..."
//                 value={excerpt}
//                 onChange={(e) => setExcerpt(e.target.value)}
//                 autoSize={{ minRows: 4, maxRows: 8 }}
//               />
//             </div>
//           </div>

//           {/* Ангилал */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconLayoutList size={13} />
//               Ангилал
//             </div>
//             <div className="nd-sidebar-field">
//               <Select
//                 className="nd-sidebar-input"
//                 mode="multiple"
//                 value={selectedCategories}
//                 onChange={setSelectedCategories}
//                 options={categories}
//                 placeholder="Ангилал сонгох"
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//                 optionRender={(opt) => (
//                   <span
//                     style={{ display: "flex", alignItems: "center", gap: 6 }}
//                   >
//                     <span
//                       style={{
//                         width: 7,
//                         height: 7,
//                         borderRadius: "50%",
//                         background: opt.data.color || "#1677ff",
//                         display: "inline-block",
//                         flexShrink: 0,
//                       }}
//                     />
//                     {opt.label}
//                   </span>
//                 )}
//                 tagRender={({ label, value, closable, onClose }) => {
//                   const cat = categories.find((c) => c.value === value);
//                   const color = cat?.color || "#1677ff";
//                   return (
//                     <Tag
//                       closable={closable}
//                       onClose={onClose}
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 500,
//                         marginRight: 3,
//                         color: color,
//                         minHeight: "30px",
//                         paddingLeft: 10,
//                         paddingRight: 8,
//                         display: "inline-flex",
//                         alignItems: "center",
//                         background: `${color}15`,
//                         borderColor: `${color}`,
//                       }}
//                     >
//                       {label}
//                     </Tag>
//                   );
//                 }}
//               />
//             </div>
//           </div>

//           {/* Таг */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconTag size={13} />
//               Таг
//             </div>
//             <div className="nd-sidebar-field">
//               <Select
//                 className="nd-sidebar-input"
//                 mode="multiple"
//                 value={selectedTags}
//                 onChange={setSelectedTags}
//                 options={tags}
//                 placeholder="Таг сонгох"
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//                 tagRender={({ label, closable, onClose }) => (
//                   <Tag
//                     color="green"
//                     closable={closable}
//                     onClose={onClose}
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 500,
//                       marginRight: 3,
//                       minHeight: "30px",
//                       paddingLeft: 10,
//                       paddingRight: 8,
//                       display: "inline-flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     {label}
//                   </Tag>
//                 )}
//               />
//             </div>
//           </div>

//           {/* Устгах */}
//           <div className="nd-sidebar-footer">
//             <button
//               className="nd-delete-btn"
//               onClick={() => setDeleteConfirmOpen(true)}
//             >
//               <DeleteOutlined />
//               Нийтлэлийг устгах
//             </button>
//           </div>
//         </aside>
//       </div>

//       {/* ── Зургийн сан Modal ── */}
//       {/* <Modal
//         open={mediaModalOpen}
//         onCancel={() => setMediaModalOpen(false)}
//         footer={null}
//         title="Зургийн сан"
//         width={700}
//         centered
//       > */}
//       <Modal
//         open={mediaModalOpen}
//         onCancel={() => setMediaModalOpen(false)}
//         footer={null}
//         title={
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               paddingRight: 32,
//             }}
//           >
//             <span>Зургийн сан</span>
//             <Upload
//               showUploadList={false}
//               accept="image/jpeg,image/png,image/webp"
//               customRequest={async ({ file }) => {
//                 const formData = new FormData();
//                 formData.append("image", file);
//                 const res = await api.upload_image(formData);
//                 if (res?.status === 201) {
//                   // Зургийн санд нэмж, шууд сонгох
//                   setMediaImages((prev) => [res.data, ...prev]);
//                   handleSelectFromMedia(res.data.url);
//                   toast("Зураг амжилттай байршлаа", "success");
//                 } else {
//                   toast("Зураг байршуулахад алдаа гарлаа", "error");
//                 }
//               }}
//             >
//               <Button icon={<UploadOutlined />} size="small">
//                 Компьютерээс
//               </Button>
//             </Upload>
//           </div>
//         }
//         width={700}
//         centered
//       >
//         {mediaLoading ? (
//           <div style={{ textAlign: "center", padding: 48 }}>
//             <Spin />
//           </div>
//         ) : (
//           <div className="nd-media-grid">
//             {mediaImages.length === 0 ? (
//               <div className="nd-media-empty">Зураг байхгүй байна</div>
//             ) : (
//               mediaImages.map((img) => (
//                 <div
//                   key={img.uid || img.id}
//                   className="nd-media-item"
//                   onClick={() => handleSelectFromMedia(img.url)}
//                 >
//                   <img src={img.url} alt={img.name || ""} />
//                 </div>
//               ))
//             )}
//           </div>
//         )}
//       </Modal>

//       {/* ── Устгах confirm ── */}
//       <ConfirmModal
//         variant="error"
//         title="Итгэлтэй байна уу?"
//         showModal={deleteConfirmOpen}
//         setShowModal={setDeleteConfirmOpen}
//         submitHandler={handleDelete}
//         description={
//           <>
//             <span style={{ fontWeight: 600 }}>"Нийтлэл устгах"</span> үйлдлийг
//             буцаах боломжгүйг анхаарна уу.
//           </>
//         }
//       />
//     </section>
//   );
// }

"use client";
import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Input,
  Tag,
  Spin,
  Badge,
  Switch,
  DatePicker,
  Modal,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  SaveOutlined,
  PictureOutlined,
  DeleteOutlined,
  SettingOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  IconStar,
  IconTag,
  IconLayoutList,
  IconCalendar,
} from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Quote from "@editorjs/quote";
import Delimiter from "@editorjs/delimiter";
import ImageTool from "@editorjs/image";
import dayjs from "dayjs";
import api from "../../../api";
import Select from "antd/es/select";
import { useToast } from "../../../components/toast";
import ConfirmModal from "../../../components/modal/ConfirmModal";

const EDITOR_ID = "news-editorjs";

export default function NewsDetail() {
  const { slug: slugParam } = useParams();
  const navigate = useNavigate();
  const editorInstanceRef = useRef(null);
  const titleRef = useRef(null);

  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [title, setTitle] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [status, setStatus] = useState("DRAFT");
  const [featured, setFeatured] = useState(false);
  const [publishedAt, setPublishedAt] = useState(null);
  const [slug, setSlug] = useState("");

  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  // Thumb
  const [thumbPreview, setThumbPreview] = useState(null);
  const [thumbUploading, setThumbUploading] = useState(false);
  const [thumbSourceOpen, setThumbSourceOpen] = useState(false);

  // Cover
  const [coverPreview, setCoverPreview] = useState(null);
  const [coverUploading, setCoverUploading] = useState(false);
  const [coverSourceOpen, setCoverSourceOpen] = useState(false);

  // Media modal
  const [mediaModalOpen, setMediaModalOpen] = useState(false);
  const [mediaImages, setMediaImages] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaTarget, setMediaTarget] = useState("cover"); // "cover" | "thumb"

  // Delete
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const toast = useToast();

  // title утга тавигдсаны дараа өндөр тохируулах
  useEffect(() => {
    if (!titleRef.current || !title) return;
    const el = titleRef.current;
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  }, [title, loading]);

  // ── Media татах ───────────────────────────────────
  useEffect(() => {
    if (!mediaModalOpen) return;
    const fetchMedia = async () => {
      setMediaLoading(true);
      const res = await api.media_list();
      if (res?.status === 200) {
        setMediaImages(res.data || []);
      } else {
        toast("Медиа авахад алдаа гарлаа", "error");
      }
      setMediaLoading(false);
    };
    fetchMedia();
  }, [mediaModalOpen]);

  // ── Taxonomy татах ────────────────────────────────
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await api.news_taxonomies_list();
        const list = res.data.data || [];
        setCategories(
          list
            .filter((t) => t.type === "CATEGORY")
            .map((t) => ({ label: t.name, value: t.id, color: t.color })),
        );
        setTags(
          list
            .filter((t) => t.type === "TAG")
            .map((t) => ({ label: t.name, value: t.id })),
        );
      } catch {}
    };
    fetch_();
  }, []);

  // ── Мэдээ татах ───────────────────────────────────
  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      const res = await api.news_detail(slugParam);

      if (res.status === 200) {
        const item = res.data.data;
        setNews(item);
        setTitle(item.title || "");
        setExcerpt(item.excerpt || "");
        setStatus(item.status || "DRAFT");
        setFeatured(item.featured || false);
        setPublishedAt(item.publishedAt ? dayjs(item.publishedAt) : null);
        setSlug(item.slug || "");
        setSelectedCategories(
          item.taxonomies
            ?.filter((t) => t.type === "CATEGORY")
            .map((t) => t.id) || [],
        );
        setSelectedTags(
          item.taxonomies?.filter((t) => t.type === "TAG").map((t) => t.id) ||
            [],
        );
        if (item.cover?.url) setCoverPreview(item.cover.url);
        if (item.thumbnail?.url) setThumbPreview(item.thumbnail.url);
      } else {
        toast(res?.data?.message || "Мэдээ татахад алдаа гарлаа", "error");
      }
      setLoading(false);
    };
    fetchNews();
  }, [slugParam]);

  // ── EditorJS init ─────────────────────────────────
  useEffect(() => {
    if (loading || !news) return;

    const initEditor = async () => {
      if (editorInstanceRef.current) {
        try {
          await editorInstanceRef.current.isReady;
          editorInstanceRef.current.destroy();
        } catch {}
        editorInstanceRef.current = null;
      }

      let initialData = { blocks: [] };
      try {
        if (news.content) initialData = JSON.parse(news.content);
      } catch {}

      editorInstanceRef.current = new EditorJS({
        holder: EDITOR_ID,
        tools: {
          header: { class: Header, inlineToolbar: true },
          list: { class: List, inlineToolbar: true },
          quote: { class: Quote, inlineToolbar: true },
          delimiter: Delimiter,
          // Ганц зураг оруулах блок
          // api.upload_image нь request.js дотор withCredentials/cookie-г
          // аль хэдийн зөв удирддаг тул endpoints биш uploadByFile ашиглана
          image: {
            class: ImageTool,
            config: {
              uploader: {
                uploadByFile: async (file) => {
                  const formData = new FormData();
                  formData.append("image", file);
                  const res = await api.upload_image(formData);
                  if (res?.status === 201) {
                    return { success: 1, file: { url: res.data.url } };
                  }
                  return { success: 0 };
                },
                uploadByUrl: async (url) => {
                  return { success: 1, file: { url } };
                },
              },
            },
          },
        },
        data: initialData,
        placeholder: "Агуулгаа энд бичнэ үү...",
      });
    };

    initEditor();

    return () => {
      if (editorInstanceRef.current) {
        editorInstanceRef.current.isReady
          .then(() => {
            editorInstanceRef.current?.destroy();
            editorInstanceRef.current = null;
          })
          .catch(() => {
            editorInstanceRef.current = null;
          });
      }
    };
  }, [loading, news]);

  // ── Thumb: компьютерээс upload ────────────────────
  const handleThumbUpload = async ({ file }) => {
    setThumbUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.upload_image(formData);
    if (res?.status === 201) {
      setThumbPreview(res.data.url);
      setThumbSourceOpen(false);
      toast("Зураг амжилттай байршлаа", "success");
    } else {
      toast("Зураг байршуулахад алдаа гарлаа", "error");
    }
    setThumbUploading(false);
  };

  // ── Cover: компьютерээс upload ────────────────────
  const handleCoverUpload = async ({ file }) => {
    setCoverUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.upload_image(formData);
    if (res?.status === 201) {
      setCoverPreview(res.data.url);
      setCoverSourceOpen(false);
      toast("Зураг амжилттай байршлаа", "success");
    } else {
      toast("Зураг байршуулахад алдаа гарлаа", "error");
    }
    setCoverUploading(false);
  };

  // ── Cover/Thumb: зургийн сангаас сонгох ───────────
  const handleSelectFromMedia = (url) => {
    if (mediaTarget === "thumb") {
      setThumbPreview(url);
    } else {
      setCoverPreview(url);
    }
    setMediaModalOpen(false);
  };

  // ── Cover: устгах ─────────────────────────────────
  const handleRemoveCover = (e) => {
    e.stopPropagation();
    setCoverPreview(null);
    setCoverSourceOpen(false);
  };

  // ── Хадгалах ──────────────────────────────────────
  const handleSave = async (publishOverride) => {
    setSaving(true);
    const editorData = await editorInstanceRef?.current?.save();
    const taxonomyIds = [...selectedCategories, ...selectedTags];
    const newStatus = publishOverride ?? status;

    // Cover тооцоолох
    let coverData = news?.cover || null;
    if (coverPreview && coverPreview !== news?.cover?.url) {
      coverData = { url: coverPreview };
    } else if (!coverPreview) {
      coverData = null;
    }

    // Thumbnail тооцоолох
    let thumbnailData = news?.thumbnail || null;
    if (thumbPreview && thumbPreview !== news?.thumbnail?.url) {
      thumbnailData = { url: thumbPreview };
    } else if (!thumbPreview) {
      thumbnailData = null;
    }

    // URL-ийн slugParam-аар (одоо байгаа record) update хийнэ,
    // body дотор шинэ slug (хэрэглэгч өөрчилсэн бол) дамжуулна
    const res = await api.news_update(slugParam, {
      title,
      slug,
      excerpt,
      content: JSON.stringify(editorData),
      status: newStatus,
      featured,
      taxonomyIds,
      publishedAt: publishedAt ? publishedAt.toISOString() : null,
      cover: coverData,
      thumbnail: thumbnailData,
    });

    if (res.status === 200) {
      setNews((prev) => ({ ...prev, status: newStatus }));
      if (publishOverride) setStatus(publishOverride);

      // Slug өөрчлөгдсөн бол URL-ийг шинэ slug руу сольж,
      // дараагийн save/refresh slugParam зөв байхад туслана
      if (res.data?.data?.slug && res.data.data.slug !== slugParam) {
        navigate(`/news/${res.data.data.slug}`, { replace: true });
      }

      toast(
        publishOverride === "PUBLISHED" ? "Нийтлэгдлээ" : "Хадгалагдлаа",
        "success",
      );
    } else {
      toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
    }
    setSaving(false);
  };

  // ── Устгах ────────────────────────────────────────
  const handleDelete = async () => {
    setDeleting(true);
    try {
      // id биш — URL-ийн slugParam-аар устгана
      await api.news_delete(slugParam);
      toast("Устгагдлаа", "success");
      navigate("/news");
    } catch {
      toast("Устгахад алдаа гарлаа", "error");
    } finally {
      setDeleting(false);
      setDeleteConfirmOpen(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", paddingTop: 80 }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <section className="news-detail-section">
      {/* ── Topbar ── */}
      <div className="nd-topbar">
        <Button
          icon={<ArrowLeftOutlined />}
          variant="text"
          color="default"
          onClick={() => navigate("/news")}
        >
          Буцах
        </Button>
        <div className="nd-topbar-right">
          <Badge
            dot
            color={news?.status === "PUBLISHED" ? "green" : "gold"}
            text={
              <span style={{ fontSize: 13, color: "#000", fontWeight: 500 }}>
                {news?.status === "PUBLISHED" ? "Нийтлэгдсэн" : "Ноорог"}
              </span>
            }
          />
          <Button
            icon={<SaveOutlined />}
            loading={saving}
            onClick={() => handleSave()}
          >
            Хадгалах
          </Button>
        </div>
      </div>

      {/* ── Body ── */}
      <div className="nd-body">
        {/* ── Editor талбар ── */}
        <div className="nd-editor-wrap">
          {/* Cover */}
          <div className="nd-cover-wrap">
            {coverPreview ? (
              <div className="nd-cover-preview">
                <img src={coverPreview} alt="cover" />
                <button className="nd-cover-remove" onClick={handleRemoveCover}>
                  <DeleteOutlined />
                </button>
                <div
                  className="nd-cover-overlay"
                  onClick={() => {
                    setMediaTarget("cover");
                    setMediaModalOpen(true);
                  }}
                >
                  <PictureOutlined style={{ fontSize: 15 }} />
                  <span>Зураг солих</span>
                </div>
              </div>
            ) : (
              <div
                className="nd-cover-placeholder"
                onClick={() => {
                  setMediaTarget("cover");
                  setMediaModalOpen(true);
                }}
              >
                <PlusOutlined style={{ fontSize: 14 }} />
                <span>Онцлох ковер нэмэх</span>
              </div>
            )}

            {/* Source сонголт */}
            {coverSourceOpen && (
              <div className="nd-cover-source-btns">
                <button
                  className="nd-cover-source-btn"
                  onClick={() => {
                    setCoverSourceOpen(false);
                    setMediaModalOpen(true);
                  }}
                >
                  <PictureOutlined style={{ fontSize: 16 }} />
                  <span>Зургийн сангаас</span>
                </button>
                <Upload
                  showUploadList={false}
                  accept="image/jpeg,image/png,image/webp"
                  customRequest={handleCoverUpload}
                  disabled={coverUploading}
                >
                  <button
                    className="nd-cover-source-btn"
                    disabled={coverUploading}
                  >
                    <UploadOutlined style={{ fontSize: 16 }} />
                    <span>
                      {coverUploading ? "Байршуулж байна..." : "Компьютерээс"}
                    </span>
                  </button>
                </Upload>
              </div>
            )}
          </div>

          {/* Editor агуулга */}
          <div className="nd-editor-content">
            <textarea
              ref={titleRef}
              className="nd-title-input"
              placeholder="Гарчиг..."
              value={title}
              rows={1}
              onChange={(e) => {
                setTitle(e.target.value);
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
              }}
            />
            <div id={EDITOR_ID} className="nd-editor" />
          </div>
        </div>

        {/* ── Sidebar ── */}
        <aside className="nd-sidebar">
          <div className="nd-sidebar-header">
            <SettingOutlined style={{ color: "#5e5e5e", fontSize: 15 }} />
            Тохиргоо
          </div>

          {/* Төлөв */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">Төлөв</div>
            <div className="nd-status-btns">
              <button
                className={`nd-status-btn ${status === "DRAFT" ? "active-draft" : ""}`}
                onClick={() => setStatus("DRAFT")}
              >
                Ноорог
              </button>
              <button
                className={`nd-status-btn ${status === "PUBLISHED" ? "active-published" : ""}`}
                onClick={() => setStatus("PUBLISHED")}
              >
                Нийтлэх
              </button>
            </div>
          </div>

          {/* Thumbnail */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">
              <PictureOutlined size={13} />
              Thumbnail зураг
            </div>
            <div className="nd-sidebar-field">
              {thumbPreview ? (
                <div className="nd-thumb-preview">
                  <img src={thumbPreview} alt="thumbnail" />
                  <div className="nd-thumb-actions">
                    <button
                      className="nd-thumb-btn"
                      onClick={() => {
                        setMediaTarget("thumb");
                        setMediaModalOpen(true);
                      }}
                    >
                      <PictureOutlined /> Солих
                    </button>
                    <button
                      className="nd-thumb-btn danger"
                      onClick={() => setThumbPreview(null)}
                    >
                      <DeleteOutlined />
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  className="nd-thumb-placeholder"
                  onClick={() => {
                    setMediaTarget("thumb");
                    setMediaModalOpen(true);
                  }}
                >
                  <PlusOutlined />
                  <span>Thumbnail нэмэх</span>
                </div>
              )}

              {thumbSourceOpen && (
                <div className="nd-cover-source-btns">
                  <button
                    className="nd-cover-source-btn"
                    onClick={() => {
                      setThumbSourceOpen(false);
                      setMediaModalOpen(true);
                    }}
                  >
                    <PictureOutlined style={{ fontSize: 16 }} />
                    <span>Зургийн сангаас</span>
                  </button>
                  <Upload
                    showUploadList={false}
                    accept="image/jpeg,image/png,image/webp"
                    customRequest={handleThumbUpload}
                    disabled={thumbUploading}
                  >
                    <button
                      className="nd-cover-source-btn"
                      disabled={thumbUploading}
                    >
                      <UploadOutlined style={{ fontSize: 16 }} />
                      <span>
                        {thumbUploading ? "Байршуулж байна..." : "Компьютерээс"}
                      </span>
                    </button>
                  </Upload>
                </div>
              )}
            </div>
          </div>

          {/* Slug */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">
              <IconCalendar size={13} />
              Slug
            </div>
            <div className="nd-sidebar-field">
              <Input
                className="nd-sidebar-input"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                }}
              />
            </div>
          </div>

          {/* Нийтлэх огноо */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">
              <IconCalendar size={13} />
              Нийтлэх огноо
            </div>
            <div className="nd-sidebar-field">
              <DatePicker
                value={publishedAt}
                onChange={setPublishedAt}
                showTime
                format="YYYY/MM/DD HH:mm"
                placeholder="Огноо сонгох"
                className="nd-sidebar-input"
              />
            </div>
          </div>

          {/* Онцлох */}
          <div className="nd-sidebar-section">
            <div className="nd-inline-field" style={{ marginBottom: 0 }}>
              <div className="nd-inline-label">
                <IconStar size={15} color="#faad14" />
                <span className="nd-sidebar-section-title">
                  Онцлох мэдээ болгох
                </span>
              </div>
              <Switch checked={featured} onChange={setFeatured} size="small" />
            </div>
          </div>

          {/* Товч агуулга */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">Товч агуулга</div>
            <div className="nd-sidebar-field">
              <Input.TextArea
                className="nd-excerpt-textarea"
                placeholder="Мэдээний товч тайлбар..."
                value={excerpt}
                onChange={(e) => setExcerpt(e.target.value)}
                autoSize={{ minRows: 4, maxRows: 8 }}
              />
            </div>
          </div>

          {/* Ангилал */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">
              <IconLayoutList size={13} />
              Ангилал
            </div>
            <div className="nd-sidebar-field">
              <Select
                className="nd-sidebar-input"
                mode="multiple"
                value={selectedCategories}
                onChange={setSelectedCategories}
                options={categories}
                placeholder="Ангилал сонгох"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                optionRender={(opt) => (
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <span
                      style={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        background: opt.data.color || "#1677ff",
                        display: "inline-block",
                        flexShrink: 0,
                      }}
                    />
                    {opt.label}
                  </span>
                )}
                tagRender={({ label, value, closable, onClose }) => {
                  const cat = categories.find((c) => c.value === value);
                  const color = cat?.color || "#1677ff";
                  return (
                    <Tag
                      closable={closable}
                      onClose={onClose}
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        marginRight: 3,
                        color: color,
                        minHeight: "30px",
                        paddingLeft: 10,
                        paddingRight: 8,
                        display: "inline-flex",
                        alignItems: "center",
                        background: `${color}15`,
                        borderColor: `${color}`,
                      }}
                    >
                      {label}
                    </Tag>
                  );
                }}
              />
            </div>
          </div>

          {/* Таг */}
          <div className="nd-sidebar-section">
            <div className="nd-sidebar-section-title">
              <IconTag size={13} />
              Таг
            </div>
            <div className="nd-sidebar-field">
              <Select
                className="nd-sidebar-input"
                mode="multiple"
                value={selectedTags}
                onChange={setSelectedTags}
                options={tags}
                placeholder="Таг сонгох"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                tagRender={({ label, closable, onClose }) => (
                  <Tag
                    color="green"
                    closable={closable}
                    onClose={onClose}
                    style={{
                      fontSize: 13,
                      fontWeight: 500,
                      marginRight: 3,
                      minHeight: "30px",
                      paddingLeft: 10,
                      paddingRight: 8,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    {label}
                  </Tag>
                )}
              />
            </div>
          </div>

          {/* Устгах */}
          <div className="nd-sidebar-footer">
            <button
              className="nd-delete-btn"
              onClick={() => setDeleteConfirmOpen(true)}
            >
              <DeleteOutlined />
              Нийтлэлийг устгах
            </button>
          </div>
        </aside>
      </div>

      {/* ── Зургийн сан Modal ── */}
      <Modal
        open={mediaModalOpen}
        onCancel={() => setMediaModalOpen(false)}
        footer={null}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingRight: 32,
            }}
          >
            <span>Зургийн сан</span>
            <Upload
              showUploadList={false}
              accept="image/jpeg,image/png,image/webp"
              customRequest={async ({ file }) => {
                const formData = new FormData();
                formData.append("image", file);
                const res = await api.upload_image(formData);
                if (res?.status === 201) {
                  setMediaImages((prev) => [res.data, ...prev]);
                  handleSelectFromMedia(res.data.url);
                  toast("Зураг амжилттай байршлаа", "success");
                } else {
                  toast("Зураг байршуулахад алдаа гарлаа", "error");
                }
              }}
            >
              <Button icon={<UploadOutlined />} size="small">
                Компьютерээс
              </Button>
            </Upload>
          </div>
        }
        width={700}
        centered
      >
        {mediaLoading ? (
          <div style={{ textAlign: "center", padding: 48 }}>
            <Spin />
          </div>
        ) : (
          <div className="nd-media-grid">
            {mediaImages.length === 0 ? (
              <div className="nd-media-empty">Зураг байхгүй байна</div>
            ) : (
              mediaImages.map((img) => (
                <div
                  key={img.uid || img.id}
                  className="nd-media-item"
                  onClick={() => handleSelectFromMedia(img.url)}
                >
                  <img src={img.url} alt={img.name || ""} />
                </div>
              ))
            )}
          </div>
        )}
      </Modal>

      {/* ── Устгах confirm ── */}
      <ConfirmModal
        variant="error"
        title="Итгэлтэй байна уу?"
        showModal={deleteConfirmOpen}
        setShowModal={setDeleteConfirmOpen}
        submitHandler={handleDelete}
        description={
          <>
            <span style={{ fontWeight: 600 }}>"Нийтлэл устгах"</span> үйлдлийг
            буцаах боломжгүйг анхаарна уу.
          </>
        }
      />
    </section>
  );
}

// "use client";
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Button,
//   Input,
//   Tag,
//   Spin,
//   Badge,
//   Switch,
//   DatePicker,
//   Modal,
//   Upload,
// } from "antd";
// import {
//   ArrowLeftOutlined,
//   SaveOutlined,
//   PictureOutlined,
//   DeleteOutlined,
//   SettingOutlined,
//   UploadOutlined,
//   PlusOutlined,
// } from "@ant-design/icons";
// import {
//   IconStar,
//   IconTag,
//   IconLayoutList,
//   IconCalendar,
// } from "@tabler/icons-react";
// import { useNavigate, useParams } from "react-router-dom";
// import EditorJS from "@editorjs/editorjs";
// import Header from "@editorjs/header";
// import List from "@editorjs/list";
// import Quote from "@editorjs/quote";
// import Delimiter from "@editorjs/delimiter";
// import dayjs from "dayjs";
// import api from "../../../api";
// import Select from "antd/es/select";
// import { useToast } from "../../../components/toast";
// import ConfirmModal from "../../../components/modal/ConfirmModal";
// import ImageTool from "@editorjs/image";

// const EDITOR_ID = "news-editorjs";

// export default function NewsDetail() {
//   const { slug: slugParam } = useParams();
//   const navigate = useNavigate();
//   const editorInstanceRef = useRef(null);
//   const titleRef = useRef(null);

//   const [news, setNews] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);

//   const [title, setTitle] = useState("");
//   const [excerpt, setExcerpt] = useState("");
//   const [status, setStatus] = useState("DRAFT");
//   const [featured, setFeatured] = useState(false);
//   const [publishedAt, setPublishedAt] = useState(null);
//   const [slug, setSlug] = useState("");

//   const [categories, setCategories] = useState([]);
//   const [tags, setTags] = useState([]);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);

//   // Thumb
//   const [thumbPreview, setThumbPreview] = useState(null);
//   const [thumbUploading, setThumbUploading] = useState(false);
//   const [thumbSourceOpen, setThumbSourceOpen] = useState(false);

//   // Cover
//   const [coverPreview, setCoverPreview] = useState(null);
//   const [coverUploading, setCoverUploading] = useState(false);
//   const [coverSourceOpen, setCoverSourceOpen] = useState(false);

//   // Media modal
//   const [mediaModalOpen, setMediaModalOpen] = useState(false);
//   const [mediaImages, setMediaImages] = useState([]);
//   const [mediaLoading, setMediaLoading] = useState(false);
//   const [mediaTarget, setMediaTarget] = useState("cover"); // "cover" | "thumb"

//   // Delete
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
//   const [deleting, setDeleting] = useState(false);

//   const toast = useToast();

//   // title утга тавигдсаны дараа өндөр тохируулах
//   useEffect(() => {
//     if (!titleRef.current || !title) return;
//     const el = titleRef.current;
//     el.style.height = "auto";
//     el.style.height = el.scrollHeight + "px";
//   }, [title, loading]);

//   // ── Media татах ───────────────────────────────────
//   useEffect(() => {
//     if (!mediaModalOpen) return;
//     const fetchMedia = async () => {
//       setMediaLoading(true);
//       const res = await api.media_list();
//       if (res?.status === 200) {
//         setMediaImages(res.data || []);
//       } else {
//         toast("Медиа авахад алдаа гарлаа", "error");
//       }
//       setMediaLoading(false);
//     };
//     fetchMedia();
//   }, [mediaModalOpen]);

//   // ── Taxonomy татах ────────────────────────────────
//   useEffect(() => {
//     const fetch_ = async () => {
//       try {
//         const res = await api.news_taxonomies_list();
//         const list = res.data.data || [];
//         setCategories(
//           list
//             .filter((t) => t.type === "CATEGORY")
//             .map((t) => ({ label: t.name, value: t.id, color: t.color })),
//         );
//         setTags(
//           list
//             .filter((t) => t.type === "TAG")
//             .map((t) => ({ label: t.name, value: t.id })),
//         );
//       } catch {}
//     };
//     fetch_();
//   }, []);

//   // ── Мэдээ татах ───────────────────────────────────
//   useEffect(() => {
//     const fetchNews = async () => {
//       setLoading(true);
//       const res = await api.news_detail(slugParam);

//       // console.log("news detail ", res);
//       if (res.status === 200) {
//         const item = res.data.data;
//         setNews(item);
//         setTitle(item.title || "");
//         setExcerpt(item.excerpt || "");
//         setStatus(item.status || "DRAFT");
//         setFeatured(item.featured || false);
//         setPublishedAt(item.publishedAt ? dayjs(item.publishedAt) : null);
//         setSlug(item.slug || "");
//         setSelectedCategories(
//           item.taxonomies
//             ?.filter((t) => t.type === "CATEGORY")
//             .map((t) => t.id) || [],
//         );
//         setSelectedTags(
//           item.taxonomies?.filter((t) => t.type === "TAG").map((t) => t.id) ||
//             [],
//         );
//         if (item.cover?.url) setCoverPreview(item.cover.url);
//         if (item.thumbnail?.url) setThumbPreview(item.thumbnail.url);
//       } else {
//         toast(res?.data?.message || "Мэдээ татахад алдаа гарлаа", "error");
//       }
//       setLoading(false);
//     };
//     fetchNews();
//   }, [slugParam]);

//   // ── EditorJS init ─────────────────────────────────
//   useEffect(() => {
//     if (loading || !news) return;

//     const initEditor = async () => {
//       if (editorInstanceRef.current) {
//         try {
//           await editorInstanceRef.current.isReady;
//           editorInstanceRef.current.destroy();
//         } catch {}
//         editorInstanceRef.current = null;
//       }

//       let initialData = { blocks: [] };
//       try {
//         if (news.content) initialData = JSON.parse(news.content);
//       } catch {}

//       editorInstanceRef.current = new EditorJS({
//         holder: EDITOR_ID,
//         tools: {
//           header: { class: Header, inlineToolbar: true },
//           list: { class: List, inlineToolbar: true },
//           quote: { class: Quote, inlineToolbar: true },
//           delimiter: Delimiter,
//         },
//         image: {
//           class: ImageTool,
//           config: {
//             uploader: {
//               uploadByFile: async (file) => {
//                 const formData = new FormData();
//                 formData.append("image", file);
//                 const res = await api.upload_image(formData);
//                 if (res?.status === 201) {
//                   return { success: 1, file: { url: res.data.url } };
//                 }
//                 return { success: 0 };
//               },
//               uploadByUrl: async (url) => {
//                 return { success: 1, file: { url } };
//               },
//             },
//           },
//         },
//         // Олон зургийг grid-ээр харуулах блок
//         // gallery: {
//         //   class: GalleryTool,
//         //   config: {
//         //     uploadByFile: async (file) => {
//         //       const formData = new FormData();
//         //       formData.append("image", file);
//         //       const res = await api.upload_image(formData);
//         //       if (res?.status === 201) {
//         //         return { url: res.data.url };
//         //       }
//         //       throw new Error("Зураг байршуулахад алдаа гарлаа");
//         //     },
//         //   },
//         // },
//         data: initialData,
//         placeholder: "Агуулгаа энд бичнэ үү...",
//       });
//     };

//     initEditor();

//     return () => {
//       if (editorInstanceRef.current) {
//         editorInstanceRef.current.isReady
//           .then(() => {
//             editorInstanceRef.current?.destroy();
//             editorInstanceRef.current = null;
//           })
//           .catch(() => {
//             editorInstanceRef.current = null;
//           });
//       }
//     };
//   }, [loading, news]);

//   // ── Thumb: компьютерээс upload ────────────────────
//   const handleThumbUpload = async ({ file }) => {
//     setThumbUploading(true);
//     const formData = new FormData();
//     formData.append("image", file);
//     const res = await api.upload_image(formData);
//     if (res?.status === 201) {
//       setThumbPreview(res.data.url);
//       setThumbSourceOpen(false);
//       toast("Зураг амжилттай байршлаа", "success");
//     } else {
//       toast("Зураг байршуулахад алдаа гарлаа", "error");
//     }
//     setThumbUploading(false);
//   };

//   // ── Cover: компьютерээс upload ────────────────────
//   const handleCoverUpload = async ({ file }) => {
//     setCoverUploading(true);
//     const formData = new FormData();
//     formData.append("image", file);
//     const res = await api.upload_image(formData);
//     if (res?.status === 201) {
//       setCoverPreview(res.data.url);
//       setCoverSourceOpen(false);
//       toast("Зураг амжилттай байршлаа", "success");
//     } else {
//       toast("Зураг байршуулахад алдаа гарлаа", "error");
//     }
//     setCoverUploading(false);
//   };

//   // ── Cover/Thumb: зургийн сангаас сонгох ───────────
//   const handleSelectFromMedia = (url) => {
//     if (mediaTarget === "thumb") {
//       setThumbPreview(url);
//     } else {
//       setCoverPreview(url);
//     }
//     setMediaModalOpen(false);
//   };

//   // ── Cover: устгах ─────────────────────────────────
//   const handleRemoveCover = (e) => {
//     e.stopPropagation();
//     setCoverPreview(null);
//     setCoverSourceOpen(false);
//   };

//   // ── Хадгалах ──────────────────────────────────────
//   const handleSave = async (publishOverride) => {
//     setSaving(true);
//     const editorData = await editorInstanceRef?.current?.save();
//     const taxonomyIds = [...selectedCategories, ...selectedTags];
//     const newStatus = publishOverride ?? status;

//     // Cover тооцоолох
//     let coverData = news?.cover || null;
//     if (coverPreview && coverPreview !== news?.cover?.url) {
//       coverData = { url: coverPreview };
//     } else if (!coverPreview) {
//       coverData = null;
//     }

//     // Thumbnail тооцоолох
//     let thumbnailData = news?.thumbnail || null;
//     if (thumbPreview && thumbPreview !== news?.thumbnail?.url) {
//       thumbnailData = { url: thumbPreview };
//     } else if (!thumbPreview) {
//       thumbnailData = null;
//     }

//     // URL-ийн slugParam-аар (одоо байгаа record) update хийнэ,
//     // body дотор шинэ slug (хэрэглэгч өөрчилсэн бол) дамжуулна
//     const res = await api.news_update(slugParam, {
//       title,
//       slug,
//       excerpt,
//       content: JSON.stringify(editorData),
//       status: newStatus,
//       featured,
//       taxonomyIds,
//       publishedAt: publishedAt ? publishedAt.toISOString() : null,
//       cover: coverData,
//       thumbnail: thumbnailData,
//     });

//     if (res.status === 200) {
//       setNews((prev) => ({ ...prev, status: newStatus }));
//       if (publishOverride) setStatus(publishOverride);

//       // Slug өөрчлөгдсөн бол URL-ийг шинэ slug руу сольж,
//       // дараагийн save/refresh slugParam зөв байхад туслана
//       if (res.data?.data?.slug && res.data.data.slug !== slugParam) {
//         navigate(`/news/${res.data.data.slug}`, { replace: true });
//       }

//       toast(
//         publishOverride === "PUBLISHED" ? "Нийтлэгдлээ" : "Хадгалагдлаа",
//         "success",
//       );
//     } else {
//       toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
//     }
//     setSaving(false);
//   };

//   // ── Устгах ────────────────────────────────────────
//   const handleDelete = async () => {
//     setDeleting(true);
//     try {
//       // id биш — URL-ийн slugParam-аар устгана
//       await api.news_delete(slugParam);
//       toast("Устгагдлаа", "success");
//       navigate("/news");
//     } catch {
//       toast("Устгахад алдаа гарлаа", "error");
//     } finally {
//       setDeleting(false);
//       setDeleteConfirmOpen(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         style={{ display: "flex", justifyContent: "center", paddingTop: 80 }}
//       >
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <section className="news-detail-section">
//       {/* ── Topbar ── */}
//       <div className="nd-topbar">
//         <Button
//           icon={<ArrowLeftOutlined />}
//           variant="text"
//           color="default"
//           onClick={() => navigate("/news")}
//         >
//           Буцах
//         </Button>
//         <div className="nd-topbar-right">
//           <Badge
//             dot
//             color={news?.status === "PUBLISHED" ? "green" : "gold"}
//             text={
//               <span style={{ fontSize: 13, color: "#000", fontWeight: 500 }}>
//                 {news?.status === "PUBLISHED" ? "Нийтлэгдсэн" : "Ноорог"}
//               </span>
//             }
//           />
//           <Button
//             icon={<SaveOutlined />}
//             loading={saving}
//             onClick={() => handleSave()}
//           >
//             Хадгалах
//           </Button>
//         </div>
//       </div>

//       {/* ── Body ── */}
//       <div className="nd-body">
//         {/* ── Editor талбар ── */}
//         <div className="nd-editor-wrap">
//           {/* Cover */}
//           <div className="nd-cover-wrap">
//             {coverPreview ? (
//               <div className="nd-cover-preview">
//                 <img src={coverPreview} alt="cover" />
//                 <button className="nd-cover-remove" onClick={handleRemoveCover}>
//                   <DeleteOutlined />
//                 </button>
//                 <div
//                   className="nd-cover-overlay"
//                   onClick={() => {
//                     setMediaTarget("cover");
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PictureOutlined style={{ fontSize: 15 }} />
//                   <span>Зураг солих</span>
//                 </div>
//               </div>
//             ) : (
//               <div
//                 className="nd-cover-placeholder"
//                 onClick={() => {
//                   setMediaTarget("cover");
//                   setMediaModalOpen(true);
//                 }}
//               >
//                 <PlusOutlined style={{ fontSize: 14 }} />
//                 <span>Онцлох ковер нэмэх</span>
//               </div>
//             )}

//             {/* Source сонголт */}
//             {coverSourceOpen && (
//               <div className="nd-cover-source-btns">
//                 <button
//                   className="nd-cover-source-btn"
//                   onClick={() => {
//                     setCoverSourceOpen(false);
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PictureOutlined style={{ fontSize: 16 }} />
//                   <span>Зургийн сангаас</span>
//                 </button>
//                 <Upload
//                   showUploadList={false}
//                   accept="image/jpeg,image/png,image/webp"
//                   customRequest={handleCoverUpload}
//                   disabled={coverUploading}
//                 >
//                   <button
//                     className="nd-cover-source-btn"
//                     disabled={coverUploading}
//                   >
//                     <UploadOutlined style={{ fontSize: 16 }} />
//                     <span>
//                       {coverUploading ? "Байршуулж байна..." : "Компьютерээс"}
//                     </span>
//                   </button>
//                 </Upload>
//               </div>
//             )}
//           </div>

//           {/* Editor агуулга */}
//           <div className="nd-editor-content">
//             <textarea
//               ref={titleRef}
//               className="nd-title-input"
//               placeholder="Гарчиг..."
//               value={title}
//               rows={1}
//               onChange={(e) => {
//                 setTitle(e.target.value);
//                 e.target.style.height = "auto";
//                 e.target.style.height = e.target.scrollHeight + "px";
//               }}
//             />
//             <div id={EDITOR_ID} className="nd-editor" />
//           </div>
//         </div>

//         {/* ── Sidebar ── */}
//         <aside className="nd-sidebar">
//           <div className="nd-sidebar-header">
//             <SettingOutlined style={{ color: "#5e5e5e", fontSize: 15 }} />
//             Тохиргоо
//           </div>

//           {/* Төлөв */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">Төлөв</div>
//             <div className="nd-status-btns">
//               <button
//                 className={`nd-status-btn ${status === "DRAFT" ? "active-draft" : ""}`}
//                 onClick={() => setStatus("DRAFT")}
//               >
//                 Ноорог
//               </button>
//               <button
//                 className={`nd-status-btn ${status === "PUBLISHED" ? "active-published" : ""}`}
//                 onClick={() => setStatus("PUBLISHED")}
//               >
//                 Нийтлэх
//               </button>
//             </div>
//           </div>

//           {/* Thumbnail */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <PictureOutlined size={13} />
//               Thumbnail зураг
//             </div>
//             <div className="nd-sidebar-field">
//               {thumbPreview ? (
//                 <div className="nd-thumb-preview">
//                   <img src={thumbPreview} alt="thumbnail" />
//                   <div className="nd-thumb-actions">
//                     <button
//                       className="nd-thumb-btn"
//                       onClick={() => {
//                         setMediaTarget("thumb");
//                         setMediaModalOpen(true);
//                       }}
//                     >
//                       <PictureOutlined /> Солих
//                     </button>
//                     <button
//                       className="nd-thumb-btn danger"
//                       onClick={() => setThumbPreview(null)}
//                     >
//                       <DeleteOutlined />
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="nd-thumb-placeholder"
//                   onClick={() => {
//                     setMediaTarget("thumb");
//                     setMediaModalOpen(true);
//                   }}
//                 >
//                   <PlusOutlined />
//                   <span>Thumbnail нэмэх</span>
//                 </div>
//               )}

//               {thumbSourceOpen && (
//                 <div className="nd-cover-source-btns">
//                   <button
//                     className="nd-cover-source-btn"
//                     onClick={() => {
//                       setThumbSourceOpen(false);
//                       setMediaModalOpen(true);
//                     }}
//                   >
//                     <PictureOutlined style={{ fontSize: 16 }} />
//                     <span>Зургийн сангаас</span>
//                   </button>
//                   <Upload
//                     showUploadList={false}
//                     accept="image/jpeg,image/png,image/webp"
//                     customRequest={handleThumbUpload}
//                     disabled={thumbUploading}
//                   >
//                     <button
//                       className="nd-cover-source-btn"
//                       disabled={thumbUploading}
//                     >
//                       <UploadOutlined style={{ fontSize: 16 }} />
//                       <span>
//                         {thumbUploading ? "Байршуулж байна..." : "Компьютерээс"}
//                       </span>
//                     </button>
//                   </Upload>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Slug */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconCalendar size={13} />
//               Slug
//             </div>
//             <div className="nd-sidebar-field">
//               <Input
//                 className="nd-sidebar-input"
//                 value={slug}
//                 onChange={(e) => {
//                   setSlug(e.target.value);
//                 }}
//               />
//             </div>
//           </div>

//           {/* Нийтлэх огноо */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconCalendar size={13} />
//               Нийтлэх огноо
//             </div>
//             <div className="nd-sidebar-field">
//               <DatePicker
//                 value={publishedAt}
//                 onChange={setPublishedAt}
//                 showTime
//                 format="YYYY/MM/DD HH:mm"
//                 placeholder="Огноо сонгох"
//                 className="nd-sidebar-input"
//               />
//             </div>
//           </div>

//           {/* Онцлох */}
//           <div className="nd-sidebar-section">
//             <div className="nd-inline-field" style={{ marginBottom: 0 }}>
//               <div className="nd-inline-label">
//                 <IconStar size={15} color="#faad14" />
//                 <span className="nd-sidebar-section-title">
//                   Онцлох мэдээ болгох
//                 </span>
//               </div>
//               <Switch checked={featured} onChange={setFeatured} size="small" />
//             </div>
//           </div>

//           {/* Товч агуулга */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">Товч агуулга</div>
//             <div className="nd-sidebar-field">
//               <Input.TextArea
//                 className="nd-excerpt-textarea"
//                 placeholder="Мэдээний товч тайлбар..."
//                 value={excerpt}
//                 onChange={(e) => setExcerpt(e.target.value)}
//                 autoSize={{ minRows: 4, maxRows: 8 }}
//               />
//             </div>
//           </div>

//           {/* Ангилал */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconLayoutList size={13} />
//               Ангилал
//             </div>
//             <div className="nd-sidebar-field">
//               <Select
//                 className="nd-sidebar-input"
//                 mode="multiple"
//                 value={selectedCategories}
//                 onChange={setSelectedCategories}
//                 options={categories}
//                 placeholder="Ангилал сонгох"
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//                 optionRender={(opt) => (
//                   <span
//                     style={{ display: "flex", alignItems: "center", gap: 6 }}
//                   >
//                     <span
//                       style={{
//                         width: 7,
//                         height: 7,
//                         borderRadius: "50%",
//                         background: opt.data.color || "#1677ff",
//                         display: "inline-block",
//                         flexShrink: 0,
//                       }}
//                     />
//                     {opt.label}
//                   </span>
//                 )}
//                 tagRender={({ label, value, closable, onClose }) => {
//                   const cat = categories.find((c) => c.value === value);
//                   const color = cat?.color || "#1677ff";
//                   return (
//                     <Tag
//                       closable={closable}
//                       onClose={onClose}
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 500,
//                         marginRight: 3,
//                         color: color,
//                         minHeight: "30px",
//                         paddingLeft: 10,
//                         paddingRight: 8,
//                         display: "inline-flex",
//                         alignItems: "center",
//                         background: `${color}15`,
//                         borderColor: `${color}`,
//                       }}
//                     >
//                       {label}
//                     </Tag>
//                   );
//                 }}
//               />
//             </div>
//           </div>

//           {/* Таг */}
//           <div className="nd-sidebar-section">
//             <div className="nd-sidebar-section-title">
//               <IconTag size={13} />
//               Таг
//             </div>
//             <div className="nd-sidebar-field">
//               <Select
//                 className="nd-sidebar-input"
//                 mode="multiple"
//                 value={selectedTags}
//                 onChange={setSelectedTags}
//                 options={tags}
//                 placeholder="Таг сонгох"
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//                 tagRender={({ label, closable, onClose }) => (
//                   <Tag
//                     color="green"
//                     closable={closable}
//                     onClose={onClose}
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 500,
//                       marginRight: 3,
//                       minHeight: "30px",
//                       paddingLeft: 10,
//                       paddingRight: 8,
//                       display: "inline-flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     {label}
//                   </Tag>
//                 )}
//               />
//             </div>
//           </div>

//           {/* Устгах */}
//           <div className="nd-sidebar-footer">
//             <button
//               className="nd-delete-btn"
//               onClick={() => setDeleteConfirmOpen(true)}
//             >
//               <DeleteOutlined />
//               Нийтлэлийг устгах
//             </button>
//           </div>
//         </aside>
//       </div>

//       {/* ── Зургийн сан Modal ── */}
//       <Modal
//         open={mediaModalOpen}
//         onCancel={() => setMediaModalOpen(false)}
//         footer={null}
//         title={
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               paddingRight: 32,
//             }}
//           >
//             <span>Зургийн сан</span>
//             <Upload
//               showUploadList={false}
//               accept="image/jpeg,image/png,image/webp"
//               customRequest={async ({ file }) => {
//                 const formData = new FormData();
//                 formData.append("image", file);
//                 const res = await api.upload_image(formData);
//                 if (res?.status === 201) {
//                   setMediaImages((prev) => [res.data, ...prev]);
//                   handleSelectFromMedia(res.data.url);
//                   toast("Зураг амжилттай байршлаа", "success");
//                 } else {
//                   toast("Зураг байршуулахад алдаа гарлаа", "error");
//                 }
//               }}
//             >
//               <Button icon={<UploadOutlined />} size="small">
//                 Компьютерээс
//               </Button>
//             </Upload>
//           </div>
//         }
//         width={700}
//         centered
//       >
//         {mediaLoading ? (
//           <div style={{ textAlign: "center", padding: 48 }}>
//             <Spin />
//           </div>
//         ) : (
//           <div className="nd-media-grid">
//             {mediaImages.length === 0 ? (
//               <div className="nd-media-empty">Зураг байхгүй байна</div>
//             ) : (
//               mediaImages.map((img) => (
//                 <div
//                   key={img.uid || img.id}
//                   className="nd-media-item"
//                   onClick={() => handleSelectFromMedia(img.url)}
//                 >
//                   <img src={img.url} alt={img.name || ""} />
//                 </div>
//               ))
//             )}
//           </div>
//         )}
//       </Modal>

//       {/* ── Устгах confirm ── */}
//       <ConfirmModal
//         variant="error"
//         title="Итгэлтэй байна уу?"
//         showModal={deleteConfirmOpen}
//         setShowModal={setDeleteConfirmOpen}
//         submitHandler={handleDelete}
//         description={
//           <>
//             <span style={{ fontWeight: 600 }}>"Нийтлэл устгах"</span> үйлдлийг
//             буцаах боломжгүйг анхаарна уу.
//           </>
//         }
//       />
//     </section>
//   );
// }
